/* eslint-disable no-unused-vars */
import React from 'react'
import { Input, Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { SearchOutlined } from '@ant-design/icons'
import { CustomCol, CustomTitle } from 'src/components'

interface ValidateDepositsListHeaderProps {
  quantity: number
  filterText: string
  setFilterText: (value: string) => void
}

const ValidateDepositsListHeader: React.FC<ValidateDepositsListHeaderProps> = (props) => {
  const { quantity, filterText, setFilterText } = props
  const { t } = useTranslation()

  return <Row>
    {/* Title */}
    <CustomCol lg={18}>
      <CustomTitle
        label={`${t('general.ResultsLength', { length: quantity })}`}
        type={null}
      />
    </CustomCol>

    {/* Text */}
    <CustomCol lg={6}>
      <Input
        allowClear
        value={filterText}
        onChange={(e) => {
          const value = e.target.value
          if (!value || value.trim().length === 0) { setFilterText(null) }
          else { setFilterText(value) }
        }}
        placeholder={t('Withdrawals.Filter')}
        prefix={<SearchOutlined />}
      />
    </CustomCol>
  </Row>
}

export default ValidateDepositsListHeader
